import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1a33f37c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "DifficultySettingsContainer"
};
const _hoisted_2 = {
  class: "wd100 border flex flex-col pd12 flex items-center justify-center"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "boldFont"
}, "舒尔特方格闪图", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "闪烁时长", -1));
const _hoisted_5 = {
  class: "wd100 border flex flex-col pd12 flex items-center justify-center"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "boldFont"
}, "黑白子", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "闪烁时长", -1));
const _hoisted_8 = {
  class: "wd100 border flex flex-col pd12 flex items-center justify-center"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "boldFont"
}, "打地鼠", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "动画时长", -1));
const _hoisted_11 = {
  class: "wd100 border flex flex-col pd12 flex items-center justify-center"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "boldFont"
}, "快速记忆", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图例时长", -1));
const _hoisted_14 = {
  class: "wd100 border flex flex-col pd12 flex items-center justify-center"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "boldFont"
}, "808A消失", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图例时长", -1));
const _hoisted_17 = {
  class: "wd100 border flex flex-col pd12 flex items-center justify-center"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "boldFont"
}, "E808E消失", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图例时长", -1));
const _hoisted_20 = {
  class: "wd100 border flex flex-col pd12 flex items-center justify-center"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "boldFont"
}, "摩斯密码消失", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图例时长", -1));
const _hoisted_23 = {
  class: "wd100 border flex flex-col pd12 flex items-center justify-center"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "boldFont"
}, "摩斯密码消失4", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图例时长", -1));
const _hoisted_26 = {
  class: "wd100 border flex flex-col pd12 bothCenter"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "boldFont"
}, "摩斯密码消失5", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图例时长", -1));
const _hoisted_29 = {
  class: "wd100 border flex flex-col pd12 flex items-center justify-center"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "boldFont"
}, "彩色方格记忆", -1));
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "显示时长(ms)", -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "间隔时长(ms)", -1));
const _hoisted_33 = {
  class: "wd100 border flex flex-col pd12 flex items-center justify-center"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "boldFont"
}, "图形记忆力", -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "准备时长(ms)", -1));
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "闪烁时长(ms)", -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "间隔时长(ms)", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 6,
      class: "flex items-center pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_row, {
        class: "flex items-center justify-center mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.FlashDiamond.flashInterval,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.settings.FlashDiamond.flashInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 flex items-center justify-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => $options.updateSetting('FlashDiamond'))
        }, {
          default: _withCtx(() => [_createTextVNode("更新难度设置")]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "flex items-center pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_row, {
        class: "flex items-center justify-center mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.BlackWhiteDot.flashInterval,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.settings.BlackWhiteDot.flashInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 flex items-center justify-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = $event => $options.updateSetting('BlackWhiteDot'))
        }, {
          default: _withCtx(() => [_createTextVNode("更新难度设置")]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "flex items-center pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_el_row, {
        class: "flex items-center justify-center mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.WhackAMole.playInterval,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.settings.WhackAMole.playInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 flex items-center justify-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = $event => $options.updateSetting('WhackAMole'))
        }, {
          default: _withCtx(() => [_createTextVNode("更新难度设置")]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "flex items-center pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_el_row, {
        class: "flex items-center justify-center mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_hoisted_13]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.FastMemory.flashInterval,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.settings.FastMemory.flashInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 flex items-center justify-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[7] || (_cache[7] = $event => $options.updateSetting('FastMemory'))
        }, {
          default: _withCtx(() => [_createTextVNode("更新难度设置")]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "flex items-center pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createVNode(_component_el_row, {
        class: "flex items-center justify-center mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_hoisted_16]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.E808A.flashInterval,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.settings.E808A.flashInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 flex items-center justify-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[9] || (_cache[9] = $event => $options.updateSetting('E808A'))
        }, {
          default: _withCtx(() => [_createTextVNode("更新难度设置")]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "flex items-center pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_hoisted_18, _createVNode(_component_el_row, {
        class: "flex items-center justify-center mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_hoisted_19]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.E808E.flashInterval,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.settings.E808E.flashInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 flex items-center justify-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[11] || (_cache[11] = $event => $options.updateSetting('E808E'))
        }, {
          default: _withCtx(() => [_createTextVNode("更新难度设置")]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "flex items-center pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_hoisted_21, _createVNode(_component_el_row, {
        class: "flex items-center justify-center mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_hoisted_22]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.MossCopy.flashInterval,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.settings.MossCopy.flashInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 flex items-center justify-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[13] || (_cache[13] = $event => $options.updateSetting('MossCopy'))
        }, {
          default: _withCtx(() => [_createTextVNode("更新难度设置")]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "flex items-center pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_hoisted_24, _createVNode(_component_el_row, {
        class: "bothCenter mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_hoisted_25]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.MossMissing4.flashInterval,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.settings.MossMissing4.flashInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 bothCenter"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[15] || (_cache[15] = $event => $options.updateSetting('MossMissing4'))
        }, {
          default: _withCtx(() => [_createTextVNode("更新难度设置")]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "flex items-center pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_hoisted_27, _createVNode(_component_el_row, {
        class: "bothCenter mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_hoisted_28]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.MossMissing5.flashInterval,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.settings.MossMissing5.flashInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 bothCenter"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[17] || (_cache[17] = $event => $options.updateSetting('MossMissing5'))
        }, {
          default: _withCtx(() => [_createTextVNode("更新难度设置")]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "flex items-center pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_29, [_hoisted_30, _createVNode(_component_el_row, {
        class: "flex items-center justify-center mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_hoisted_31]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "毫秒",
            modelValue: $data.settings.ColorGridMemory.showMs,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.settings.ColorGridMemory.showMs = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "flex items-center justify-center mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_hoisted_32]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "毫秒",
            modelValue: $data.settings.ColorGridMemory.gapMs,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.settings.ColorGridMemory.gapMs = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 flex items-center justify-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[20] || (_cache[20] = $event => $options.updateSetting('ColorGridMemory'))
        }, {
          default: _withCtx(() => [_createTextVNode("更新难度设置")]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "flex items-center pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_hoisted_34, _createVNode(_component_el_row, {
        class: "flex items-center justify-center mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_hoisted_35]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.settings.ImageSequenceMemory.readyMs,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.settings.ImageSequenceMemory.readyMs = $event),
            placeholder: "0-3000"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "flex items-center justify-center mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_hoisted_36]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.settings.ImageSequenceMemory.flashMs,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.settings.ImageSequenceMemory.flashMs = $event),
            placeholder: "200-2000"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "flex items-center justify-center mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_hoisted_37]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.settings.ImageSequenceMemory.gapMs,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.settings.ImageSequenceMemory.gapMs = $event),
            placeholder: "0-1000"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 flex items-center justify-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[24] || (_cache[24] = $event => $options.updateSetting('ImageSequenceMemory'))
        }, {
          default: _withCtx(() => [_createTextVNode("更新难度设置")]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    })]),
    _: 1
  })]);
}